import { KeyboardEvent } from "react"

const NEXT_KEYS = ["ArrowRight", "ArrowDown"]
const PREVIOUS_KEYS = ["ArrowLeft", "ArrowUp"]

export function radioTargetIndex(key: string, currentIndex: number, count: number): number | null {
    if (NEXT_KEYS.includes(key)) {
        return (currentIndex + 1) % count
    }
    if (PREVIOUS_KEYS.includes(key)) {
        return (Math.max(currentIndex, 0) - 1 + count) % count
    }
    if (key === "Home") {
        return 0
    }
    return key === "End" ? count - 1 : null
}

// WAI-ARIA radio group: one tab stop on the checked option, arrows move focus and selection together
export function rovingRadioGroup<T extends string | number>(
    values: readonly T[],
    value: T | null | undefined,
    onChange: (value: T) => void
) {
    const currentIndex = value == null ? -1 : values.indexOf(value)
    const tabbableValue = currentIndex >= 0 ? values[currentIndex] : values[0]

    const onKeyDown = (event: KeyboardEvent<HTMLElement>) => {
        const radios = Array.from(event.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]'))
        const focusedIndex = radios.indexOf(event.target as HTMLElement)
        const target = radioTargetIndex(event.key, focusedIndex >= 0 ? focusedIndex : currentIndex, values.length)
        if (target === null) {
            return
        }
        event.preventDefault()
        onChange(values[target])
        radios[target]?.focus()
    }

    return { onKeyDown, tabIndexFor: (option: T) => (option === tabbableValue ? 0 : -1) }
}
